import React from 'react';
import * as LucideIcons from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { badgeConfig, collectionsConfig } from './badgeConfig';
import './BadgeInfoModal.css';

const BadgeInfoModal = ({ onClose }) => {
    const { t } = useTranslation();
    const collections = collectionsConfig(t);
    const badges = badgeConfig(t);

    return (
        <div className="modal-overlay" onClick={onClose}>
            <div className="badge-info-modal-content" onClick={(e) => e.stopPropagation()}>
                <div className="badge-info-modal-header">
                    <h2 className="text-2xl font-bold text-white">{t('badgeInfoModal.title')}</h2>
                    <button onClick={onClose} className="p-2 text-gray-400 hover:text-white"><LucideIcons.X size={24} /></button>
                </div>
                <div className="badge-info-modal-body">
                    {Object.keys(collections).map(collectionKey => {
                        const collection = collections[collectionKey];
                        const collectionBadges = Object.keys(badges).filter(badgeId => badges[badgeId].collection === collectionKey);
                        
                        // Do not render the collection if there are no badges for it.
                        if (collectionBadges.length === 0) {
                            return null;
                        }

                        return (
                            <div key={collectionKey} className="collection-section">
                                <h3 className="collection-title">{collection.name}</h3>
                                <div className="badge-grid">
                                    {collectionBadges.map(badgeId => {
                                        const badge = { id: badgeId, ...badges[badgeId] };
                                        const Icon = badge.icon;
                                        return (
                                            <div key={badge.id} className="badge-entry">
                                                <Icon size={32} className={badge.color} />
                                                <div className="badge-details">
                                                    <p className="font-bold">{badge.name}</p>
                                                    <p className="text-sm text-gray-400">{badge.description}</p>
                                                </div>
                                                <span className={`rarity-label rarity-${badge.rarity.toLowerCase()}`}>{t(`rarities.${badge.rarity.toLowerCase()}`)}</span>
                                            </div>
                                        );
                                    })}
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>
        </div>
    );
};

export default BadgeInfoModal;
